import React from "react";
import { Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/Card";

export const TimelineList = ({ title, items, dotColor, cardGradient, showActiveFirst = true }) => {
  const isValid = (val) => val !== null && val !== undefined && String(val).trim() !== "";

  const validItems = items.filter((item) => isValid(item.title) || isValid(item.subtitle) || isValid(item.duration) || isValid(item.description));

  return (
    <Card className="border-none p-0 bg-background-secondary">
      <p className="text-sm sm:text-base font-medium text-text-primary mb-4 sm:mb-5">{title}</p>

      <CardContent className="p-0">
        {!validItems.length ? (
          <p className="text-sm text-text-muted">No data available</p>
        ) : (
          <div className="flex flex-col gap-3 sm:gap-4">
            {validItems.map((item, index) => (
              <div key={index} className="flex gap-3 sm:gap-4">
                {/* ── Left timeline ── */}
                <div className="flex flex-col items-center shrink-0 self-stretch">
                  <div
                    className="w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full flex items-center justify-center mt-1 border-[2px] sm:border-[3px]"
                    style={{
                      borderColor: dotColor,
                      background: showActiveFirst && index === 0 ? dotColor : "transparent",
                    }}
                  >
                    {showActiveFirst && index === 0 && <Check size={8} className="sm:w-[10px] sm:h-[10px]" color="#fff" />}
                  </div>

                  {index < validItems.length && <div className="w-[1px] sm:w-[1.5px] flex-1 mt-1 bg-[#CAC4D0]/70" />}
                </div>

                {/* ── Content card ── */}
                <div className="flex-1 min-w-0 pb-1">
                  <div className="p-[1.5px] sm:p-[2px] rounded-lg sm:rounded-xl w-full" style={{ background: cardGradient }}>
                    <div className="p-3 sm:p-5 bg-background-tertiary/60 rounded-[8px] sm:rounded-[10px]">
                      {/* Title + duration */}
                      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-3 mb-1">
                        <p className="text-sm sm:text-base font-semibold text-text-primary leading-snug break-words">{item.title}</p>

                        {item.duration && <span className="text-[11px] sm:text-xs text-text-primary shrink-0">{item.duration}</span>}
                      </div>

                      {item.subtitle && <p className="text-xs sm:text-sm text-text-primary mb-1.5 sm:mb-2 break-words">{item.subtitle}</p>}

                      {item.description && <p className="text-xs sm:text-sm text-text-primary leading-relaxed mt-1 break-words">{item.description}</p>}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TimelineList;
